/**
 */
define('constant/myservices/myservice.list.constant',[], function () {
    var resourcePath100 = 'vendors/ucd/resources/default/images-asyn/iconset/x100/';
return {

    hasAgreementSer:[53,30,6,8,32,33,59,45,43, 59,52,40,sysParamCfg.harmonyOsCardID],
    rolloutUrl:{
        '4':'appMarketSelProd',
        '6':'pushSelProd'
    },
    deleteApi:{
        '1':'delApp',
        '2':'delApp',
        '3':'delApp',
        '7':'delApp',
        '8':'delApp',
        '9':'delApp',
        '14':'delTheme',
        '15':'delWP',
        '17':'delProduct',
        '18':'delProduct',
        '19':'delApp',
        '20':'delDynamicWp'
    },
    deleteApiParam:{
        'delApp':'appID',
        'delTheme':'themeID',
        'delWP':'wpID',
        'delProduct':'prodID'
    },
    deleteSerTips:{//todo
        '4':'应用市场服务',
        '5':'首发服务',
        '24':'电视商城服务',
        '53':'手表应用市场服务',
        '33':'社交服务',
        '40':'手机预装服务',
        '52':'游戏服务',
        '6':'PUSH服务',
        '8':'支付服务',
        '32':'帐号服务',
        '26':'权签平台服务',
        '43':'运动健康服务',
        '30-14':'主题中心服务',
        '30-15':'主题中心服务',
        '30-17':'主题中心服务',
        '30-20':'主题中心服务',
        '59':'HiAI服务'
    },
    shelfOffTips:{
        '4':'申请下架成功后，用户将不能再通过华为应用市场等渠道下载该应用。',
        '24':'申请下架成功后，用户将不能再通过华为电视商城等渠道下载该应用。',
        '53':'申请下架成功后，用户将不能再通过华为手表应用市场等渠道下载该应用。',
        '40':'申请下架成功后，该应用将不能再通过预装完成升级。',
        '30-14':'申请下架成功后，用户将不能再通过华为主题中心等渠道下载该主题。',
        '30-15':'申请下架成功后，用户将不能再通过华为主题中心等渠道下载该壁纸。',
        '30-17':'申请下架成功后，用户将不能再通过华为主题中心等渠道下载该字体。',
        '30-20':'申请下架成功后，用户将不能再通过华为主题中心等渠道下载该动态壁纸。'
    },
    services: [
     {
            name: '支付',
            serviceItem: 8,
            prodDetail: "myServiceList.payDetail",//detail路由
            icon100: resourcePath100 + 'IAP.png',
            prodType:[{id:'1',name:'移动应用'},{id:'19',name:'快应用'},{id:'2',name:'智慧屏应用'},{id:'23',name:'智慧屏快应用'},{id:'8',name:'华为VR应用'},{id:'27',name:'车机应用'},{id:'28',name:'车机快应用'}],//支持的类型下拉的选择
            title:{
                // rollout:  "申请支付服务",
                serviceLinks: sysParamCfg.myservicesUrl.payUrl,
                columns: [
                    {
                        columnField: '应用名称', columnWidth: '25%'
                    }, {
                        columnField: '应用类型', columnWidth: '15%'
                    }, {
                        columnField: '更新时间', columnWidth:'15%'
                    }, {
                        columnField: '操作', columnWidth: '20%'
                    }
                ]
            }
        },{
            name: '帐号',
            serviceItem: 32,
            icon100: resourcePath100 + 'HuaweiID.png',
            prodDetail: "myServiceList.huaweiIdDetail",//detail路由
            prodType:[{id:'1',name:'移动应用'},{id:'2',name:'智慧屏应用'},{id:'7',name:'服务器应用'},{id:'8',name:'华为VR应用'},{id:'19',name:'快应用'},{id:'21',name:'AppTouch应用'},{id:'22',name:'IOS移动应用'},{id:'23',name:'智慧屏快应用'},{id:'27',name:'车机应用'},{id:'28',name:'车机快应用'},{id:'42',name:'PC快应用'}],//支持的类型下拉的选择
            title:{
                rollout: "申请帐号服务",//发布应用事件名称
                serviceLinks: sysParamCfg.myservicesUrl.huaweiIDUrl,
                columns: [//列表栏
                    {
                        columnField: '应用名称', columnWidth:  '25%'
                    },
                    {
                        columnField: '应用类型', columnWidth:  '15%'
                    },
                    {
                        columnField: '更新时间', columnWidth:  '15%'
                    },
                    {
                        columnField: '操作', columnWidth: '20%'
                    }
                ]
            }
        },{
            name: '游戏',
            serviceItem: 52,
            icon100: resourcePath100 + 'Games.png',
            prodDetail: "myServiceList.gameDetail",//detail路由
            prodType:[{id:'1',name:'移动应用'},{id:'19',name:'免安装应用'}],//支持的类型下拉的选择
            title:{
                rollout: "申请游戏服务",//发布应用事件名称
                serviceLinks: sysParamCfg.myservicesUrl.gameUrl,
                columns: [//列表栏
                    {
                        columnField: '应用名称', columnWidth: '25%'
                    }, {
                        columnField: '应用类型', columnWidth: '20%'
                    }, {
                        columnField: '更新时间', columnWidth: '20%'
                    }, {
                        columnField: '操作', columnWidth: '30%'
                    }
                ]
            }
        }, {
            name: 'HarmonyOS开发者授权',
            serviceItem: sysParamCfg.harmonyOsCardID,
            icon100: resourcePath100 + 'Hamory-OS.png',
            prodDetail: "myServiceList.hamoryODetail",//detail路由
            prodType:[],//支持的类型下拉的选择
            title: {
                serviceLinks: sysParamCfg.myservicesUrl.harmonyUrl,
            }
        }
        ]
}

});

